import React from 'react';
import { Button } from 'primereact/button';

/**
 * Media section for recipe image and icon upload.
 */
const RecipeMediaSection = ({ formik, setImageBlob, setIconBlob }) => {
	return (
		<div className="flex gap-3">
			<div className="flex-1">
				<label htmlFor="image">Image</label>
				{formik.values.image ? (
					<div className="uploadedImage border-round border-1 border-bluegray-300 bg-gray-100 flex align-items-center justify-content-center relative">
						<img alt="Uploaded file" src={formik.values.image} className="p-mb-2 uploadedImage-image" />
						<div className="p-d-flex p-ai-center p-jc-center">
							<Button
								type="button"
								icon="pi pi-trash"
								className="absolute p-button-danger"
								style={{ top: '0.75rem', right: '0.75rem' }}
								onClick={() => {
									formik.setFieldValue('image', '');
								}}
							/>
						</div>
					</div>
				) : (
					<div
						className={`border-round relative flex flex-column align-items-center justify-content-center uploadedImage placeholderImage ${
							formik.touched.image && formik.errors.image
								? 'border-1 border-red-500 bg-red-100'
								: 'border-0 bg-bluegray-100'
						}`}
					>
						<div className="flex flex-column align-items-center justify-content-center">
							<span className="block">
								<i className="pi pi-image" style={{ fontSize: '3rem', color: '#9ca3af' }} />
							</span>
							<span className="text-gray-700 block">No image</span>
						</div>

						<div>
							<input
								className="p-inputtext p-component"
								style={{ display: 'none' }}
								id="image"
								name="image"
								type="file"
								accept="image/*"
								onChange={(event) => {
									event.persist();
									const file = event.currentTarget.files[0];
									const nextImageBlob = event.target.files[0];
									if (file) {
										const imageUrl = URL.createObjectURL(file);
										formik.setFieldValue('image', imageUrl);
									}
									setImageBlob(nextImageBlob);
								}}
							/>
							<label
								htmlFor="image"
								className="p-button p-button-text block text-indigo-500"
								style={{ cursor: 'pointer' }}
							>
								<i className="pi pi-plus" /> Upload
							</label>
						</div>
					</div>
				)}

				{formik.touched.image && formik.errors.image && (
					<small id="image-help" className="p-error">
						<i className="pi pi-exclamation-triangle mr-1" />
						{formik.errors.image}
					</small>
				)}
			</div>

			<div className="flex-1">
				<label htmlFor="icon">Icon</label>
				{formik.values.icon ? (
					<div className="uploadedImage border-round border-1 border-bluegray-300 bg-gray-100 flex align-items-center justify-content-center relative">
						<img alt="Uploaded file" src={formik.values.icon} className="p-mb-2 uploadedImage-image" />
						<div className="p-d-flex p-ai-center p-jc-center">
							<Button
								type="button"
								icon="pi pi-trash"
								className="absolute p-button-danger"
								style={{ top: '0.75rem', right: '0.75rem' }}
								onClick={() => {
									formik.setFieldValue('icon', '');
								}}
							/>
						</div>
					</div>
				) : (
					<div
						className={`border-round bg-bluegray-100 relative flex flex-column align-items-center justify-content-center uploadedImage placeholderImage ${
							formik.touched.icon && formik.errors.icon ? 'border-1 border-red-500' : 'border-0'
						}`}
					>
						<div className="flex flex-column align-items-center justify-content-center">
							<span className="block">
								<i className="pi pi-image" style={{ fontSize: '3rem', color: '#9ca3af' }} />
							</span>
							<span className="text-gray-700 block">No icon</span>
						</div>
						<div>
							<input
								className="p-inputtext p-component"
								style={{ display: 'none' }}
								id="icon"
								name="icon"
								type="file"
								accept="image/*"
								onChange={(event) => {
									event.persist();
									const file = event.currentTarget.files[0];
									const nextIconBlob = event.target.files[0];
									if (file) {
										const imageUrl = URL.createObjectURL(file);
										formik.setFieldValue('icon', imageUrl);
									}
									setIconBlob(nextIconBlob);
								}}
							/>
							<label
								htmlFor="icon"
								className="p-button p-button-text block text-indigo-500"
								style={{ cursor: 'pointer' }}
							>
								<i className="pi pi-plus" /> Upload
							</label>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default RecipeMediaSection;
